/**
 * this is a wrapper for rc-tooltip https://www.npmjs.com/package/rc-tooltip
 */
import _TOOLTIP, { RCTooltip } from 'rc-tooltip';
import React, { FCC } from 'react';
import { ITooltipProps } from './types';

import './Tooltip.scss';

const TOOLTIP = _TOOLTIP as unknown as React.AsFCC<typeof _TOOLTIP>;

/**
 * Beta
 * todo: add `__tests__`
 *
 * Tooltip is a wrapper for: https://www.npmjs.com/package/rc-tooltip
 * Note: `<Tooltip>` must have EXACTLY ONE child node that accepts onMouseEnter, onMouseLeave, onFocus, onClick event.
 */
export const Tooltip: FCC<ITooltipProps> = (props) => {
  const { placement = 'top', trigger = ['hover'], ...ttprops } = props;
  return (
    <TOOLTIP placement={placement} trigger={trigger as RCTooltip.Trigger[]} {...ttprops}>
      {props.children}
    </TOOLTIP>
  );
};

export default Tooltip;
